import React from 'react';
import Form from 'rsuite/Form';

export default function FieldText({
  name,
  label,
  accepter,
  required,
  ...rest
}) {
  return (
    <Form.Group controlId={name} className="field">
      {label && (
        <Form.ControlLabel>
          {label}
          {required && (<sup>*</sup>)}
        </Form.ControlLabel>
      )}
      <Form.Control
        accepter={accepter}
        name={name}
        size="lg"
        {...rest}
      />
    </Form.Group>
  );
}
